export const isValidUrl = (urlString: string): boolean => {
  try {
    let fullUrl = urlString;
    if (!urlString.startsWith('http://') && !urlString.startsWith('https://')) {
      fullUrl = 'https://' + urlString;
    }
    const url = new URL(fullUrl);
    if (!['http:', 'https:'].includes(url.protocol)) return false;
    const hostname = url.hostname;
    if (
      hostname.includes('..') ||
      hostname.startsWith('.') ||
      hostname.endsWith('.')
    )
      return false;
    const domainParts = hostname.split('.');
    if (domainParts.length < 2) return false;
    for (const part of domainParts) {
      if (!part || part.length === 0) return false;
      if (part.startsWith('-') || part.endsWith('-')) return false;
      if (!/^[a-zA-Z0-9-]+$/.test(part)) return false;
    }
    const tld = domainParts[domainParts.length - 1];
    if (tld.length < 2 || !/^[a-zA-Z]+$/.test(tld)) return false;
    return true;
  } catch {
    return false;
  }
};

export const extractDomain = (url: string): string => {
  try {
    let fullUrl = url;
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      fullUrl = 'https://' + url;
    }
    const urlObj = new URL(fullUrl);
    let domain = urlObj.hostname;
    if (domain.startsWith('www.')) domain = domain.substring(4);
    return domain;
  } catch (error) {
    const domainMatch = url.match(/(?:https?:\/\/)?(?:www\.)?([^\/\s]+)/);
    if (domainMatch && domainMatch[1]) {
      let domain = domainMatch[1];
      if (domain.startsWith('www.')) domain = domain.substring(4);
      return domain;
    }
    return url;
  }
};

export const normalizeUrl = (url: string): string => {
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return 'https://' + url;
};
